import { AngularServices, getAngularService } from '../core';
import { RootScopeEvents } from './../../common/services/root-scope-types';
export const setIsClosedCaptionsOpen = (isOpen) => (dispatch) => {
    dispatch({
        type: 'CAPTIONS/SET_IS_CLOSED_CAPTIONS_OPEN',
        payload: isOpen,
    });
};
export const setCaptions = (captions) => (dispatch) => {
    dispatch({
        type: 'CAPTIONS/SET_CAPTIONS',
        payload: captions,
    });
};
export const clearCaptions = () => (dispatch) => {
    dispatch({
        type: 'CAPTIONS/CLEAR_CAPTIONS',
    });
};
export const toggleClosedCaptionsOpen = (isEnabled, isPatient) => (dispatch) => {
    const VideoProviderFactory = getAngularService(AngularServices.VideoProviderFactory);
    // Set the state early before API calls
    dispatch(setIsClosedCaptionsOpen(isEnabled));
    if (isPatient) {
        // For patients, use the signaling mechanism
        const patientRealtimeActions = getAngularService('patientRealtimeActions');
        patientRealtimeActions.signalCaptionsToggle(isEnabled);
    }
    else {
        // For doctors, use the direct toggle method
        const closedCaptionsService = getAngularService('closedCaptionsService');
        closedCaptionsService.toggleCaptions(isEnabled);
    }
    if (isEnabled) {
        VideoProviderFactory.activeProvider.createSelfCaptionsSubscriber();
    }
    else {
        VideoProviderFactory.activeProvider.destroySelfCaptionsSubscriber();
    }
    if (isEnabled) {
        const rootScope = getAngularService(AngularServices.RootScope);
        rootScope.$emit(RootScopeEvents.CLOSED_CAPTIONS.USED);
    }
};
